// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label__eC1Y8 {
  font-size: 11px;
  line-height: 13px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
  display: block;
  margin-bottom: 5px;
}

.infoField__KjJcg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  padding: 11px 18px 12px 10px;
  background: var(--inputs-disable-disable-surface);
  border-radius: 5px;
}

.infoFieldValue__MF8fi {
  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
  color: var(--inputs-disable-text);
  min-height: 12px;
}

.editFieldBtn__SPcXz {
  font-size: 11px;
  line-height: 13px;
  color: var(--buttons-surface);
  text-transform: uppercase;
  text-decoration: none;
  height: auto;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.editFieldBtn__SPcXz:disabled {
  color: var(--buttons-disable);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/EditField/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,iDAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAzEF;AA2EE;EACE,6BAAA;AAzEJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.label {\n  font-size: 11px;\n  line-height: 13px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n  display: block;\n  margin-bottom: 5px;\n}\n\n.infoField {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 5px;\n  padding: 11px 18px 12px 10px;\n  background: var(--inputs-disable-disable-surface);\n  border-radius: 5px;\n}\n\n.infoFieldValue {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 12px;\n  color: var(--inputs-disable-text);\n  min-height: 12px;\n}\n\n.editFieldBtn {\n  font-size: 11px;\n  line-height: 13px;\n  color: var(--buttons-surface);\n  text-transform: uppercase;\n  text-decoration: none;\n  height: auto;\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n\n  &:disabled {\n    color: var(--buttons-disable);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label__eC1Y8`,
	"infoField": `infoField__KjJcg`,
	"infoFieldValue": `infoFieldValue__MF8fi`,
	"editFieldBtn": `editFieldBtn__SPcXz`
};
module.exports = ___CSS_LOADER_EXPORT___;
